import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IStockCountDetailEdit_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IStockCountDetailEdit_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  ReadFromLocalStorage: string;
  ReadFromLocalStorage_dummy: string;
  CountEditList: any[];
  CountEditList_dummy: any[];
  InventoryCountListSelect: any[];
  InventoryCountListSelect_dummy: any[];
  GoBack: any;
  GoBack_dummy: any;
  UpdateCount: any[];
  UpdateCount_dummy: any[];
  Notify: boolean;
  Notify_dummy: boolean;
}

export class StockCountDetailEdit_ScreenBase extends React.PureComponent<
  IStockCountDetailEdit_ScreenProps,
  any
> {
  ml = [
    {
      Id: "70da2015-72e4-4a73-bc3e-b700175ae3a3",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "3f62ac55-8b00-464f-8f39-09a269cb73f0",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        {
          Id: 807861,
          PropertyName: "value",
          Value: "Satırın Miktarını Güncelle",
        },
        { Id: 885724, PropertyName: "value", Value: "Kategori" },
        { Id: 41479, PropertyName: "value", Value: "Marka" },
        { Id: 396115, PropertyName: "label", Value: "Güncelle" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      ReadFromLocalStorage: "",
      CountEditList: [],
      InventoryCountListSelect: [],
      GoBack: "",
      UpdateCount: [],
      Notify: false,
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("stockcountdetailedit", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.StockCountDetailEditPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("stockcountdetailedit", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("stockcountdetailedit", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.StockCountDetailEditPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      stockcountdetailedit_476509_value:
        this.state.CountEditList?.at?.(0)?.countQty ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  StockCountDetailEditPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ReadFromLocalStorage =
      await ReactSystemFunctions.readFromLocalStorage(
        ReactSystemFunctions.convertToTypeByName("CountHeaderId", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.StockCountDetailEditPageInit1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  StockCountDetailEditPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.SatirID ?? this.props.screenInputs.satirid,
        "Guid"
      ),
      InventoryCountHeaderId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(this, this.state.ReadFromLocalStorage),
        "Guid"
      ),
      CountNo_1: ReactSystemFunctions.convertToTypeByName("", "string"),
      PageNumber_1: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "StockCountDetailEdit/StockCountDetailEditPageInit1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.CountEditList = result?.data.countEditList;
    formVars.stockcountdetailedit_415750_value = ReactSystemFunctions.toString(
      this,
      stateVars.CountEditList !== undefined
        ? stateVars.CountEditList?.length > 0
          ? stateVars.CountEditList[0].itemCode
          : null
        : this.state.CountEditList?.length > 0
        ? this.state.CountEditList[0].itemCode
        : null
    );
    formVars.stockcountdetailedit_898859_value = ReactSystemFunctions.toString(
      this,
      stateVars.CountEditList !== undefined
        ? stateVars.CountEditList?.length > 0
          ? stateVars.CountEditList[0].itemDescription
          : null
        : this.state.CountEditList?.length > 0
        ? this.state.CountEditList[0].itemDescription
        : null
    );
    formVars.stockcountdetailedit_918655_value = ReactSystemFunctions.toString(
      this,
      stateVars.CountEditList !== undefined
        ? stateVars.CountEditList?.length > 0
          ? stateVars.CountEditList[0].productAtt01Desc
          : null
        : this.state.CountEditList?.length > 0
        ? this.state.CountEditList[0].productAtt01Desc
        : null
    );
    formVars.stockcountdetailedit_626626_value = ReactSystemFunctions.toString(
      this,
      stateVars.CountEditList !== undefined
        ? stateVars.CountEditList?.length > 0
          ? stateVars.CountEditList[0].productAtt02Desc
          : null
        : this.state.CountEditList?.length > 0
        ? this.state.CountEditList[0].productAtt02Desc
        : null
    );
    formVars.stockcountdetailedit_476509_value = ReactSystemFunctions.value(
      this,
      stateVars.CountEditList !== undefined
        ? stateVars.CountEditList?.length > 0
          ? stateVars.CountEditList[0].countQty
          : null
        : this.state.CountEditList?.length > 0
        ? this.state.CountEditList[0].countQty
        : null
    );
    stateVars.InventoryCountListSelect = result?.data.inventoryCountListSelect;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.StockCountDetailEditPageInit2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  StockCountDetailEditPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.stockcountdetailedit_415750_value = ReactSystemFunctions.toString(
      this,
      stateVars.CountEditList !== undefined
        ? stateVars.CountEditList?.length > 0
          ? stateVars.CountEditList[0].itemCode
          : null
        : this.state.CountEditList?.length > 0
        ? this.state.CountEditList[0].itemCode
        : null
    );

    formVars.stockcountdetailedit_898859_value = ReactSystemFunctions.toString(
      this,
      stateVars.CountEditList !== undefined
        ? stateVars.CountEditList?.length > 0
          ? stateVars.CountEditList[0].itemDescription
          : null
        : this.state.CountEditList?.length > 0
        ? this.state.CountEditList[0].itemDescription
        : null
    );

    formVars.stockcountdetailedit_918655_value = ReactSystemFunctions.toString(
      this,
      stateVars.CountEditList !== undefined
        ? stateVars.CountEditList?.length > 0
          ? stateVars.CountEditList[0].productAtt01Desc
          : null
        : this.state.CountEditList?.length > 0
        ? this.state.CountEditList[0].productAtt01Desc
        : null
    );

    formVars.stockcountdetailedit_626626_value = ReactSystemFunctions.toString(
      this,
      stateVars.CountEditList !== undefined
        ? stateVars.CountEditList?.length > 0
          ? stateVars.CountEditList[0].productAtt02Desc
          : null
        : this.state.CountEditList?.length > 0
        ? this.state.CountEditList[0].productAtt02Desc
        : null
    );

    formVars.stockcountdetailedit_476509_value = ReactSystemFunctions.value(
      this,
      stateVars.CountEditList !== undefined
        ? stateVars.CountEditList?.length > 0
          ? stateVars.CountEditList[0].countQty
          : null
        : this.state.CountEditList?.length > 0
        ? this.state.CountEditList[0].countQty
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  StockCountDetailEditComponent_595058_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  StockCountDetailEditComponent_396115_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CountQty_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stockcountdetailedit_476509_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.SatirID ?? this.props.screenInputs.satirid,
        "Guid"
      ),
      InventoryCountHeaderId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(this, this.state.ReadFromLocalStorage),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "StockCountDetailEdit/StockCountDetailEditComponent_396115_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.UpdateCount = result?.data.updateCount;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.StockCountDetailEditComponent_396115_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  StockCountDetailEditComponent_396115_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.toString(
        this,
        stateVars.UpdateCount !== undefined
          ? stateVars.UpdateCount?.length > 0
            ? stateVars.UpdateCount[0].message
            : null
          : this.state.UpdateCount?.length > 0
          ? this.state.UpdateCount[0].message
          : null
      ),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      2,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.StockCountDetailEditComponent_396115_onClick2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  StockCountDetailEditComponent_396115_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.UpdateCount !== undefined
            ? stateVars.UpdateCount?.length > 0
              ? stateVars.UpdateCount[0].success
              : null
            : this.state.UpdateCount?.length > 0
            ? this.state.UpdateCount[0].success
            : null
        ),
        true
      )
    ) {
      stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.StockCountDetailEditPageInit();
    }
  }
}
